import type { ListUsersParams } from './api/usersApi';

export const usersKeys = {
  all: ['users'] as const,
  lists: () => [...usersKeys.all, 'list'] as const,
  list: (params: ListUsersParams) =>
    [...usersKeys.lists(), normalizeListParams(params)] as const,
  details: () => [...usersKeys.all, 'detail'] as const,
  detail: (userId: string) => [...usersKeys.details(), userId] as const,
  goals: (userId: string) => [...usersKeys.detail(userId), 'goals'] as const,
  goalPhases: (userId: string, goalId: string) =>
    [...usersKeys.goals(userId), goalId, 'phases'] as const,
  phaseTasks: (userId: string, goalId: string, phaseId: string) =>
    [...usersKeys.goalPhases(userId, goalId), phaseId, 'tasks'] as const,
  accessories: (userId: string) => [...usersKeys.detail(userId), 'accessories'] as const,
  notificationState: (userId: string) =>
    [...usersKeys.detail(userId), 'notification-state'] as const,
  checkins: (userId: string) => [...usersKeys.detail(userId), 'checkins'] as const,
  pointsHistory: (userId: string) =>
    [...usersKeys.detail(userId), 'points-history'] as const,
  checkinHeatmap: (userId: string) =>
    [...usersKeys.detail(userId), 'checkin-heatmap'] as const,
};

function normalizeListParams(p: ListUsersParams) {
  return {
    limit: p.limit ?? null,
    cursor: p.cursor ?? null,
    search: p.search ?? null,
    isActive: p.isActive ?? null,
  } as const;
}
